'use client'

import { isNull } from 'lodash-es'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

import { LikeButton } from '@/features/toggle-favorite-room'
import { CopyButton } from '@/shared/lib'
import { Icon } from '@/shared/ui'

type Props = {
  roomId: number
  like: boolean
  showLikeButton?: boolean
  roomUrl: string | null
}
export const ActionButtons = ({
  roomId,
  like,
  showLikeButton = true,
  roomUrl,
}: Props) => {
  const t = useTranslations('room_detail')

  const hasRoomUrl = !isNull(roomUrl)

  const [currentUrl, setCurrentUrl] = useState('')

  const url =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'local' ? currentUrl : roomUrl

  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [])

  return (
    <ul className="flex h-6 items-center justify-end gap-3">
      {hasRoomUrl && (
        <li className="h-6">
          <CopyButton
            asChild
            value={url ?? ''}
            successMessage={t('toast.link_copied')}
          >
            <button type="button" className="cursor-pointer">
              <Icon
                name="share"
                size={24}
                strokeWidth={1.5}
                className="text-black"
              />
              <span className="sr-only">{t('button.share')}</span>
            </button>
          </CopyButton>
        </li>
      )}
      {showLikeButton && (
        <li className="h-6">
          <LikeButton
            variant="line"
            roomId={roomId}
            like={like}
            className="p-0"
          />
        </li>
      )}
    </ul>
  )
}
